var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6048 0.407388C13.2546 0.0480187 12.7364 -0.085864 12.2532 0.0550651L0.985598 3.33167C0.475789 3.4733 0.114441 3.87988 0.0171011 4.39639C-0.0823396 4.92205 0.265003 5.58935 0.718788 5.86839L4.24193 8.03377C4.60328 8.25573 5.06967 8.20006 5.36869 7.89847L9.40304 3.83901C9.60613 3.62762 9.94226 3.62762 10.1453 3.83901C10.3484 4.04336 10.3484 4.37454 10.1453 4.58594L6.10399 8.6461C5.80427 8.94699 5.74825 9.41558 5.96884 9.77917L8.12152 13.3376C8.37362 13.7604 8.8078 14 9.28399 14C9.34002 14 9.40304 14 9.45907 13.993C10.0053 13.9225 10.4395 13.549 10.6005 13.0205L13.9409 1.76735C14.088 1.28819 13.9549 0.766757 13.6048 0.407388Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5954292e9c4cabc5409e89658ca176aa.svg";
export { ForwardRef as ReactComponent };